import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_4 = { class: "commands" }
const _hoisted_5 = {
  key: 0,
  class: "commands"
}
const _hoisted_6 = {
  key: 1,
  class: "commands"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = {
  key: 4,
  class: "footer"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, "RailTracing", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Lucka | "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://github.com/lucka-me/rail-tracing",
    title: "GitHub",
    target: "_blank",
    rel: "noopener"
  }, "Code")
], -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_material_button = _resolveComponent("material-button")!
  const _component_material_switch = _resolveComponent("material-switch")!
  const _component_material_slider = _resolveComponent("material-slider")!
  const _component_material_card = _resolveComponent("material-card")!

  return (_openBlock(), _createBlock(_component_material_card, { class: "panel" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`stage.${_ctx.stageText}`)), 1),
        _hoisted_2,
        _createVNode(_component_material_button, { onClick: _ctx.onClickMoreLess }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.moreLessButtonText), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.idle)
          ? (_openBlock(), _createBlock(_component_material_button, {
              key: 0,
              outlined: "",
              onClick: _ctx.onClickStart
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('start')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.confirming)
          ? (_openBlock(), _createBlock(_component_material_button, {
              key: 1,
              outlined: "",
              onClick: _ctx.onClickConfirm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('confirm')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.idle && _ctx.traceNotEmpty)
          ? (_openBlock(), _createBlock(_component_material_button, {
              key: 2,
              outlined: "",
              onClick: _ctx.onClickSelectNext
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('selectNext')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.idle && _ctx.traceNotEmpty)
          ? (_openBlock(), _createBlock(_component_material_button, {
              key: 3,
              outlined: "",
              onClick: _ctx.onClickReverse
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('reverse')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.idle && _ctx.traceNotEmpty)
          ? (_openBlock(), _createBlock(_component_material_button, {
              key: 4,
              outlined: "",
              onClick: _ctx.onClickSelectEnd
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('selectEnd')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.idle)
          ? (_openBlock(), _createBlock(_component_material_button, {
              key: 5,
              outlined: "",
              onClick: _ctx.onClickCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.idle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.traceNotEmpty)
              ? (_openBlock(), _createBlock(_component_material_button, {
                  key: 0,
                  outlined: "",
                  onClick: _ctx.onClickSave
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('save')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_material_button, {
              outlined: "",
              onClick: _ctx.onClickLoad
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('load')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            (_ctx.traceNotEmpty)
              ? (_openBlock(), _createBlock(_component_material_button, {
                  key: 1,
                  outlined: "",
                  onClick: _ctx.onClickExport
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('export')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.idle && _ctx.traceNotEmpty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_material_button, {
              outlined: "",
              onClick: _ctx.onClickRemoveLast
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('removeLastPoint')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_material_button, {
              outlined: "",
              onClick: _ctx.onClickClear
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('clearTrace')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('autoConfirmNext')), 1),
        _hoisted_9,
        _createVNode(_component_material_switch, {
          modelValue: _ctx.autoConfirmNextValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.autoConfirmNextValue) = $event))
        }, null, 8, ["modelValue"])
      ]),
      (_ctx.showMore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('angleDiffThreshold')), 1),
            _createVNode(_component_material_slider, {
              modelValue: _ctx.angleDiffThresholdValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.angleDiffThresholdValue) = $event)),
              min: 1,
              max: 180,
              label: _ctx.$t('angleDiffThreshold'),
              name: "angle-diff-threshold"
            }, null, 8, ["modelValue", "label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showMore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('satelliteLayerOpacity')), 1),
            _createVNode(_component_material_slider, {
              modelValue: _ctx.satelliteLayerOpacityValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.satelliteLayerOpacityValue) = $event)),
              label: _ctx.$t('satelliteLayerOpacityValue'),
              name: "satellite-layer-opacity"
            }, null, 8, ["modelValue", "label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showMore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}